const API_ROOT = 'https://app-node.itsecuritywire.com:3020';
const API_ROOTT= 'https://app-node-itsecuritywire.ondotmail.com:3033';
const webPath = 'https://itsecuritywire.com'

export { API_ROOT , webPath,API_ROOTT};